export default {
  container: {
    width: '100%',
    height: '100%'
  },
  blockContainer: (backgroundColor: string) => ({
    position: 'relative',
    background: backgroundColor || 'transparent',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    paddingTop: '100%'
  }),
  icon: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    p: ['40px', '64px', '48px', '56px', '64px', '56px', '64px']
  },
  heading: {
    pt: '16px'
  }
};